export default __webpack_public_path__ + "static/ndc-f1d31f65d1663e74d72a6c834d876d33.mp4";